import script from "./ReportMgmt.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportMgmt.vue?vue&type=script&setup=true&lang=ts"

import "./ReportMgmt.vue?vue&type=style&index=0&id=194e79de&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194e79de"]])

export default __exports__